class Breakdown {
    constructor(breakdown, breakdownFilter) {
        this.breakdown = breakdown || "region";
        this.breakdownFilter = breakdownFilter || "";
    }
}
const BreakdownList = [
    { key: "region", text: "Region" },
    { key: "license", text: "License" },
    { key: "location", text: "Location" },
    { key: "fullName", text: "Partner" },
    { key: "assignmentId", text: "Assignment" },
    { key: "company", text: "Company" },
    { key: "parent", text: "Parent" },
    { key: "function", text: "Function" },
    { key: "industry", text: "Industry" },
    { key: "reportGroup", text: "Report Group" },
    { key: "practiceGroup", text: "Practice Group" },
    { key: "subsector", text: "Subsector" },
    { key: "industryGroup", text: "Industry Group" },
    { key: "sector", text: "Sector" },
    { key: "capability", text: "Capability" } // requires breakdown of ["reportGroups"] json (Type: "Capability")
];
export { Breakdown, BreakdownList };
